export const formatPhoneNumber = (phone: string): string => {
    const cleaned = phone.replace(/[^\d+]/g, '');

    if (cleaned.startsWith('+7')) {
        return `+7 ${cleaned.slice(2, 5)} ${cleaned.slice(5, 8)} ${cleaned.slice(8, 10)} ${cleaned.slice(10)}`;
    }

    if (cleaned.startsWith('7') || cleaned.startsWith('8')) {
        const digits = cleaned.slice(1);
        return `+7 ${digits.slice(0, 3)} ${digits.slice(3, 6)} ${digits.slice(6, 8)} ${digits.slice(8)}`;
    }

    return cleaned.replace(/(\d{3})(?=\d)/g, '$1 ').trim();
}